import { ElementType } from 'react';
import { Box, SvgIconProps } from '@mui/material';
import { grey } from '@mui/material/colors';

type IconAvatarProps = {
  Icon: ElementType<SvgIconProps>;
  bgColor?: string;
  iconColor?: string;
};

const DEFAULT_ICON_COLOR = grey[500];
const DEFAULT_BG_COLOR = grey[100];

export const IconAvatar = ({
  Icon,
  bgColor = DEFAULT_BG_COLOR,
  iconColor = DEFAULT_ICON_COLOR,
}: IconAvatarProps) => (
  <Box
    p={1}
    bgcolor={bgColor}
    borderRadius='50%'
    display='flex'
    alignItems='center'
    justifyContent='center'
  >
    <Icon sx={{ color: iconColor }} />
  </Box>
);
